import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12e1d2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-file-field" }
const _hoisted_2 = {
  key: 0,
  class: "file-wrapper"
}
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = {
  key: 1,
  class: "loader-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "upload-wrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "file_upload", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Datei hochladen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.field.label), 1),
    (_ctx.field.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.attachment && !_ctx.uploading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.attachment.name || "Unbekannt"), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_md_button, {
                    variant: "icon",
                    grey: "",
                    mode: "icon_small",
                    icon: "file_download",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInNew()))
                  }),
                  _createVNode(_component_md_button, {
                    variant: "icon",
                    grey: "",
                    mode: "icon_small",
                    icon: "delete",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteAttachment()))
                  })
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_md_progress_indicator_circular, { size: "small" })
              ]))
        ]))
      : (_openBlock(), _createElementBlock("label", _hoisted_5, [
          (!_ctx.uploading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("input", {
                  type: "file",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadFile($event)))
                }, null, 32)
              ], 64))
            : (_openBlock(), _createBlock(_component_md_progress_indicator_circular, {
                key: 1,
                size: "small"
              }))
        ]))
  ]))
}